var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Metro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8805 3V15.1247L5.4464 10.5326L4 12.2389L12 19L20 12.2389L18.5536 10.5326L13.1195 15.1247V3H10.8805Z",
    fill: "#007D1F"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#007D1F",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro);
export default __webpack_public_path__ + "static/media/metro.ce6221e489b2ff8839221343ef27baa5.svg";
export { ForwardRef as ReactComponent };